import { Card } from "@/components/ui/card";
import { isThisWeek, isFuture, parseISO } from "date-fns";
import { AppointmentList } from "./appointment-list";

export const UpcomingAppointmentsCard = ({ appointments }) => {
    const mappedAppointments = appointments.map((a) => ({
        ...a,
        date: parseISO(a.startDate),
    }));

    const sortAsc = (a, b) => a.date - b.date;

    const upcomingAppointments = mappedAppointments
        .filter(
            (a) => isThisWeek(a.date) && isFuture(a.date) && a.statusID == 2,
        )
        .sort(sortAsc);

    return (
        <Card size="lg">
            <h2 className="mb-3 text-xl font-semibold">Upcoming this week</h2>
            {upcomingAppointments.length == 0 ? (
                <p> You have no upcoming appointments this week</p>
            ) : (
                <AppointmentList appointments={upcomingAppointments} />
            )}
        </Card>
    );
};
